import { render, staticRenderFns } from "./add-new-keywords.component.html?vue&type=template&id=c7311628&scoped=true&external"
import script from "./add-new-keywords.component.vue?vue&type=script&lang=ts"
export * from "./add-new-keywords.component.vue?vue&type=script&lang=ts"
import style0 from "./add-new-keywords.component.css?vue&type=style&index=0&id=c7311628&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7311628",
  null
  
)

export default component.exports